const ADMINISTRATOR_ERROR_CODE = {
  ADMINISTRATOR_001: 'ADMINISTRATOR001',
  ADMINISTRATOR_002: 'ADMINISTRATOR002',
  ADMINISTRATOR_003: 'ADMINISTRATOR003',
  ADMINISTRATOR_004: 'ADMINISTRATOR004',
  ADMINISTRATOR_005: 'ADMINISTRATOR005',
  ADMINISTRATOR_006: 'ADMINISTRATOR006',
  ADMINISTRATOR_007: 'ADMINISTRATOR007',
  ADMINISTRATOR_008: 'ADMINISTRATOR008',
  ADMINISTRATOR_013: 'ADMINISTRATOR013',
};

const ADMINISTRATOR_ERROR_MESSAGE = {
  [ADMINISTRATOR_ERROR_CODE.ADMINISTRATOR_001]: '유효하지 않은 이메일 형식입니다.',
  [ADMINISTRATOR_ERROR_CODE.ADMINISTRATOR_002]: '비밀번호는 필수값입니다.',
  [ADMINISTRATOR_ERROR_CODE.ADMINISTRATOR_003]: '관리자명은 필수값입니다.',
  [ADMINISTRATOR_ERROR_CODE.ADMINISTRATOR_004]: '핸드폰번호는 필수값입니다.',
  [ADMINISTRATOR_ERROR_CODE.ADMINISTRATOR_005]: '유효하지 않은 관리자 식별 ID 입니다.',
  [ADMINISTRATOR_ERROR_CODE.ADMINISTRATOR_006]: '존재하지 않은 관리자입니다.',
  [ADMINISTRATOR_ERROR_CODE.ADMINISTRATOR_007]: '이미 존재하는 이메일입니다.',
  [ADMINISTRATOR_ERROR_CODE.ADMINISTRATOR_008]: '유효하지 않은 휴대폰번호입니다.',
  [ADMINISTRATOR_ERROR_CODE.ADMINISTRATOR_013]: '권한이 없는 관리자입니다.',
};

export default ADMINISTRATOR_ERROR_MESSAGE;
